import React from 'react';
import Sidebar from '../components/sidebar';
import { Card, Row, Col, Button, Typography } from 'antd';
import { UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './SeleccionTipoCampana.css';

const { Title, Text } = Typography;

const SeleccionTipoCampana = () => {
  const navigate = useNavigate();

  const tiposCampana = [
    {
      id: 'audiencia',
      nombre: 'Campana de Audiencia',
      descripcion: 'Crea campanas dirigidas a audiencias específicas para maximizar el alcance y engagement',
      icono: <UserOutlined />,
      color: '#1890ff',
      ruta: '/campana-audiencia'
    },
    {
      id: 'video',
      nombre: 'Campana de Video',
      descripcion: 'Desarrolla campanas basadas en contenido de video para mayor impacto visual',
      icono: <VideoCameraOutlined />,
      color: '#52c41a',
      ruta: '/referidos'
    }
  ];

  const handleSeleccionarTipo = (tipo) => {
    navigate(tipo.ruta);
  };

  return (
    <div>
      <Sidebar>
        <div className="seleccion-tipo-container">
          <div className="text-center mb-4">
            <Title level={3} className="seleccion-tipo-title">
              🚀 Crear Nueva Campana
            </Title>
            <Text className="seleccion-tipo-subtitle">
              Selecciona el tipo de campana que deseas crear
            </Text>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {tiposCampana.map((tipo) => (
              <Col xs={24} sm={12} lg={8} key={tipo.id}>
                <Card
                  className={`tipo-campana-card ${tipo.id}`}
                  hoverable
                  style={{ 
                    border: `2px solid ${tipo.color}`,
                    borderRadius: '16px',
                    height: '100%',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleSeleccionarTipo(tipo)}
                >
                  <div className="text-center">
                    <div 
                      className="tipo-campana-icon"
                      style={{ color: tipo.color }}
                    >
                      {tipo.icono}
                    </div>
                    <Title level={4} style={{ color: tipo.color, margin: '16px 0 8px 0' }}>
                      {tipo.nombre}
                    </Title>
                    <Text className="tipo-campana-descripcion">
                      {tipo.descripcion}
                    </Text>
                  </div>

                  <div className="text-center mt-4">
                    <Button
                      type="primary"
                      size="large"
                      style={{
                        backgroundColor: tipo.color,
                        borderColor: tipo.color,
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        minWidth: '200px'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSeleccionarTipo(tipo);
                      }}
                    >
                      Seleccionar
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4">
            <Card className="info-card">
              <Title level={5}>💡 ¿No estás seguro?</Title>
              <Text>
                Puedes cambiar el tipo de campana en cualquier momento durante el proceso de creación.
              </Text>
            </Card>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default SeleccionTipoCampana;
